import { render } from "./DrugCatalog.vue?vue&type=template&id=5b5580bc&scoped=true"
import script from "./DrugCatalog.vue?vue&type=script&lang=js"
export * from "./DrugCatalog.vue?vue&type=script&lang=js"

import "./DrugCatalog.vue?vue&type=style&index=0&id=5b5580bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5580bc"]])

export default __exports__